export default __webpack_public_path__ + "static/media/07ka.96c65aba.png";